import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import "typeface-poppins";
import "typeface-raleway";

const AnimatedWord = ({ word, index, isVisible, isBold }) => {
  const [isWhite, setIsWhite] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timeout = setTimeout(() => {
        setIsWhite(true);
      }, index === 0 ? 0 : index * 200);

      return () => clearTimeout(timeout);
    }
  }, [isVisible, index]);

  return (
    <span
      style={{
        color: isWhite ? "#FFFFFF" : "#515151",
        transition: "color 0.5s ease",
        display: "inline-block",
        marginRight: "8px",
        fontSize: "33px",
        fontWeight: isBold ? "bold" : "normal",
      }}
    >
      {word}
    </span>
  );
};

const AnimatedText = ({ text, isVisible }) => {
  const boldWords = [
    "TowerWatch",
    "optimize",
    "use,",
    "lower",
    "costs,",
    "promote",
    "eco-friendly",
    "practices.",
  ];

  return (
    <div style={{ display: "inline" }}>
      {text.split("\n").map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {line.split(" ").map((word, wordIndex) => (
            <AnimatedWord
              key={`${lineIndex}-${wordIndex}`}
              word={word}
              index={lineIndex * 10 + wordIndex} // Unique animation delay per word
              isVisible={isVisible}
              isBold={boldWords.includes(word)}
            />
          ))}
          <br /> {/* Add a line break after each line */}
        </React.Fragment>
      ))}
    </div>
  );
};

const Page4 = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const text = `
We're excited to introduce TowerWatch—
your new partner in 
sustainable building energy control. 
By joining our waiting list,
you'll be the first to access 
powerful tools designed to 
optimize energy use, lower costs, and 
promote eco-friendly practices.

Sign up today and help create a greener 
future with us!
  `;

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      sx={{
        backgroundColor: "black",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "start",
        padding: "40px",
        boxSizing: "border-box",
        
      }}
    >
      <Box
        sx={{
          backgroundColor: "#000",
          padding: "2rem",
          textAlign: "left",
          fontFamily: "Raleway",
          fontSize: "33px",
          width: "702px",
          position: "relative",
          overflow: "hidden",
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 1.5s ease, transform 1.5s ease",
        }}
      >
        {/* Text Layer */}
        <Box sx={{ position: "relative", zIndex: 2 }}>
          <Typography sx={{ fontSize: "33px", lineHeight: "50px" }}>
            <AnimatedText text={text} isVisible={isVisible} />
          </Typography>
        </Box>
      </Box>
      {/* Gradient Lines Layer */}
      <Box
        sx={{
          position: "absolute",
          top: "76%",
          right: "0",
          transform: "translateY(-50%)",
          width: "100%",
          height: "100%",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        {[...Array(5)].map((_, index) => (
          <Box
            key={index}
            sx={{
              position: "absolute",
              top: `${index * 20}%`,
              width: "80%",
              height: "2px",
              background:
                "linear-gradient(90deg, #FFFFFF00 0%, #3C3C3C 100%)",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(-100%)",
              transition: `all 0.5s ease ${index * 0.1}s`,
              right: "0",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Page4;
